import script from "./ApplicationInfoLOC.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApplicationInfoLOC.vue?vue&type=script&setup=true&lang=ts"

import "@/styles/application-info/info-tile.css?vue&type=style&index=0&id=94439a98&scoped=true&lang=css"
import "./ApplicationInfoLOC.vue?vue&type=style&index=1&id=94439a98&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94439a98"]])

export default __exports__